import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './assets/main.scss'
import { StorageService } from './services/storage.service'
import ApiService from './services/api.service'
import HttpService from './services/base.service/HttpService'
import { PageMixin, GlobalStateMixins } from './mixins/mixins'
import { extend } from 'vee-validate'
import { required, email, confirmed, min, regex } from 'vee-validate/dist/rules'
import JsonExcel from 'vue-json-excel'

// add vee validate rule with custom message
extend('required', {
  ...required,
  message: '{_field_} tidak boleh kosong'
})
extend('email', {
  ...email,
  message: 'Format email tidak dikenali'
})

extend('confirmed', {
  ...confirmed,
  message: '{_field_} tidak sama'
})

extend('min', {
  ...min,
  message: '{_field_} minimal berisi 8 karakter'
})

extend('regex', {
  ...regex,
  message: '{_field_} harus berisi minimal 1 huruf besar dan kecil, 1 angka dan 1 karakter spesial'
})

Vue.prototype.$bus = new Vue()
export const EventBus = new Vue()

if (StorageService.getAuthdata()) {
  HttpService.setHeader()
  ApiService.setHeader()
}

Vue.config.productionTip = false

// global helper
Vue.mixin(PageMixin)
Vue.mixin(GlobalStateMixins)

// excel export
Vue.component('downloadExcel', JsonExcel)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
